import * as React from 'react';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

export default function DotsMobileStepper({activeStep, nSteps, handleNext, handleBack}) {

  return (
    <MobileStepper
      variant="dots"
      steps={nSteps}
      position="static"
      activeStep={activeStep}
      sx={{ flexGrow: 1, background: 'white'}}
      nextButton={
        <Button size="small" onClick={handleNext} disabled={activeStep === nSteps-1}>
            Siguiente
            <KeyboardArrowRight />
        </Button>
      }
      backButton={
        <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            <KeyboardArrowLeft />
            Anterior
        </Button>
      }
    />
  );
}